import React from "react";

export const Error404Page = () => {
  return <div>Error 404 - page not found</div>;
};
